<template>
 <div>
  <HeaderBg title="القائمة" />

  <div class="form_container">
    <form @submit.prevent="addLinks">

      <!-- Loop over links -->
      <div v-for="(link, index) in items" :key="index">
        <div class="input_container">
          <label> اسم الرابط باللغة العربية </label>
          <input type="text" v-model="link.title_ar">
        </div>
        <div class="input_container">
          <label> اسم الرابط باللغة الإنجليزية </label>
          <input type="text" v-model="link.title_en">
        </div>
        <div class="input_container">
          <label> الرابط </label>
          <input type="text" v-model="link.uri">
        </div>
        <div class="input_container">
          <label> الترتيب </label>
          <input type="text" v-model="link.order">
        </div>
        <div class="input_container">
          <label> مفعل </label>
          <select v-model="link.active">
            <option value="1">نعم</option>
            <option value="0">لا</option>
          </select>
        </div>

        <!-- Delete button for each link -->
        <!-- <button type="button" class="deleteBtn" @click="removeLink(index)">
          حذف
        </button> -->
        <hr>
      </div>

      <!-- Add new link button -->
      <!-- <div>
        <button type="button" class="addMoreBtn" @click="addLink">
          أضف رابط أخر +
        </button>
      </div> -->

      <!-- Success / Error messages -->
      <div class="alert alert-success mt-2" role="alert" v-if="successMessage">
        تم التعديل بنجاح
      </div>
      <div class="alert alert-danger mt-2" role="alert" v-if="ErrorCheck">
        <p v-for="(error, index) in errors" :key="index"> {{ error }} </p>
      </div>

      <!-- Save Button -->
      <button class="saveBtn" v-if="!postLoaded">
        حفظ +
      </button>
      <button class="saveBtn" v-if="postLoaded">
        <b-spinner></b-spinner>
      </button>
    </form>
  </div>
</div>

</template>

<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import axios from 'axios';
import Request from '../../../services/Request';
export default {
  name: 'NavBarMenu',
  components: { HeaderBg },
  data() {
    return {
      postLoaded: false,
      successMessage: false,
      items: [
        { 
          id: '',
          title_ar: '',
          title_en: '',
          uri: '',
          order: '',
          active: ''
        }
      ],
      errors: [],
      ErrorCheck: false,
    }
  },
  mounted(){
    this.getLinks();
  },
  methods: {
    addLink() {
    this.items.push({
      id: '',
      title_ar: '',
      title_en: '',
      uri: '',
      order: '',
      active: ''
    });
  },
  removeLink(index) {
    this.items.splice(index, 1);
  },

    addLinks() {
    this.successMessage = false;
    this.postLoaded = true;
    this.errors = [];
    this.ErrorCheck = false;

    // send all links
    axios.post("https://app.almujtama.com.sa/admin/menus", {items:this.items}, {
      headers: { 
        Authorization: `Bearer ${localStorage.getItem("token")}`
      }
    })
    .then(() => {
      this.postLoaded = false;
      this.ErrorCheck = false;
      this.successMessage = true;
    })
    .catch(err => {
      if (err.response && err.response.data && err.response.data.errors) {
        this.errors = err.response.data.errors;
        this.ErrorCheck = true;
      }
      this.postLoaded = false;
    });
  },

    getLinks() {
      Request.fetch(`admin/menus`, '')
        .then((response) => {
          console.log(response, 'rererere')
          this.items = []
          response.data.data.forEach((item) => {
            
            this.items.push({
              id: item.id,
              title_ar: item.title_ar,
              title_en: item.title_en,
              uri: item.uri,
              order: item.order,
              active: item.active
            });
          });
        })
        .catch(err => {
          if (Request.statusIsFaield(err)) {
            this.$router.push('/login');
            localStorage.removeItem('token');
          }
        });
    }

  }
}
</script>

<style lang="scss" scoped>
.addMoreBtn{
    border: 0;
    background-color: #656565;
    color: #FFF;
    display: inline-block;
    padding: 10px 10px;
    border-radius: 4px;
    font-size: 16px;
    margin-right: 20px;
}
.deleteBtn{
    border: 0;
    background-color: rgba(255, 0, 0, 0.667);
    color: #FFF;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 10px 10px;
    border-radius: 4px;
    font-size: 12px;
    margin-right: 20px;
}
.form_container{
    background-color: #FFF;
    border-radius: 10px;
    margin: 40px auto;
    padding: 70px 100px;
    @media (max-width: 576px) {
        width: 97%;
        padding: 30px;
    }
    form{
        > div{
            margin-bottom: 40px;
            label{
                display: block;
                text-align: center;
                font-size: 16px;
                color: #717171;
                font-weight: 600;
                margin-bottom: 10px;
            }
            input,
            select{
                border: 1px solid #71717191;
                font-size: 16px;
                padding: 5px 10px;
                border-radius: 10px;
                display: block;
                margin: auto;
                width: 50%;
            }
        }
    }
}
.upload_img{
            display: flex;
            align-items: center;
            margin-bottom: 40px;
            width: 100%;
            span{
                font-size: 16px;
                color: #656565;
                margin-left: 50px;
            }
            .img_container{
                width: 80px;
                height: 80px;
                border-radius: 50%;
                background-color: #FAFAFA;
                display: flex;
                justify-content: center;
                align-items: center;
                position: relative;
                img{
                    width: 100%;
                }
                .photo_upload{
                    
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    bottom: 0;
                    right: 0;
                    img{
                        width: 70%;
                    }
                }
            }
        }
</style>